import { render, staticRenderFns } from "./user-info.vue?vue&type=template&id=634a2450"
import script from "./user-info.vue?vue&type=script&lang=js"
export * from "./user-info.vue?vue&type=script&lang=js"
import style0 from "./_scss/userInfo.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports